<template>
    <v-layout align-center justify-space-between>
        <h3 class="font-weight-medium">{{ title }}</h3>
        <v-btn color="secondary"
               outlined
               small
               v-if="buttonVisibility"
               :disabled="disableButton"
               @click="onClick">
            <v-icon left small>{{ icon || ICONS.PLUS }}</v-icon>
            {{ buttonTitle || '' }}
        </v-btn>
    </v-layout>
</template>

<script>
import { ICONS } from '@/constants/icons';

export default {
    name: 'TableTitle',
    data: () => ({
        ICONS
    }),
    props: {
        title: {
            type: String,
            required: true
        },
        buttonTitle: {
            type: String,
            required: false
        },
        disableButton: {
            type: Boolean,
            'default': false
        },
        buttonVisibility: {
            type: Boolean,
            'default': true
        },
        icon: {
            type: String,
            required: false
        }
    },
    methods: {
        onClick () {
            this.$emit('click');
        }
    }
};
</script>

<style scoped>

</style>
